<template>
  <div :class="{ 'u-hidden': !filteredItems.length }" class="u-pos-relative">
    <button class="c-button c-button--fullwidth c-button--icon c-button--white" :class="{'is-open': open}" type="button"
            @click="toggleFilter(filterName)" :title="selectionHints">
      <div class="c-filter-checkbox-hints">{{ filterName }}</div>
      <!-- Arrow down icon -->
      <svgicon
        style="transition-property: transform; transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1); transition-duration: 150ms;"
        :class="[ open ? 'svg-up' : 'svg-down' ]" name="arrow-right" height=".7em"></svgicon>
    </button>

    <div v-show="open">
      <div class="c-filter-checkbox-options">
        <v-filter-checkbox-element
          v-for="item in filteredItems" :name="item[itemName]+item[itemValue]"
          :key="item[itemValue]" :value="item"
          @item-selected="itemSelected">
          {{ item[itemName] }} <span v-if="item.Count && item.Count > 0 && item.IsSelected"
                                     style="font-size: smaller; color: #C8C8C8">({{ item.Count }})</span>
        </v-filter-checkbox-element>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VFilterCheckboxElement from '@/components/form/filters/FilterCheckboxElement'
import VInput from '@/components/form/Input'
import vClickOutside from 'v-click-outside';

// Register outside Click plugin
Vue.use(vClickOutside);

export default {
  props: {
    items: {type: Array, default: () => []},
    filterName: String,
    itemName: {type: String, default: 'name'},
    itemValue: {type: String, default: 'value'},
    allowMultiple: {type: Boolean, default: true},
    width: {type: Number, default: 0},
    openOnLoad: {type: Boolean, default: false}
  },
  data() {
    sessionStorage.getItem(this.filterName) === null ? sessionStorage.setItem(this.filterName, this.openOnLoad) : null

    return {
      open: (sessionStorage.getItem(this.filterName) === 'true'),
    }
  },
  components: {
    VFilterCheckboxElement,
    VInput,
  },
  computed: {
    checkedItems() {
      let output = [];
      this.items.map(item => {
        if (item.IsSelected) {
          output.push(item);
        }
      });
      return output;
    },
    filteredItems() {
      if (typeof this.items !== "undefined") {
        return this.items;
      }
    },
    selectionHints() {
      return this.checkedItems.map(item => {
        return `${item[this.itemName]}`
      }).join();
    }
  },
  methods: {
    itemSelected(value) {
      //if allowMultiple = false -> uncheck all that don't have this value
      if (!this.allowMultiple) {
        this.items.forEach(item => {
          if (item.Value !== value) {
            item.IsSelected = false;
          }
        });
      }

      this.$emit('input', this.checkedItems);
      this.$emit('change');
      sessionStorage.setItem('customerFilters', window.location.search);
    },
    toggleFilter() {
      this.open = !this.open;
      if (this.open) {
        sessionStorage.setItem(this.filterName, true);
      } else {
        sessionStorage.setItem(this.filterName, false);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/private";

.c-button {
  background-color: palette(color-neutral, x-light);
  border-color: palette(color-neutral, x-light);
  text-transform: uppercase;
  padding: em($global-spacing-unit-small) em($global-spacing-unit-tiny);
}

button:focus {
  box-shadow: none !important;
}

.c-filter-checkbox {
  display: flex;
  align-items: center;
  width: 105px;
}

.c-filter-checkbox-hints {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.c-filter-checkbox__toggle {
  position: relative;
  width: 100%;
  background-color: white;
  border: none;
  box-shadow: inset 0 0 0 1px palette(color-neutral, medium);
  padding: em($global-spacing-unit-tiny*1.5) em($global-spacing-unit-small);
  padding-right: em($global-spacing-unit*1.25);
  text-align: left;

  @include down($desktop) {
    padding: em($global-spacing-unit-tiny) em($global-spacing-unit-tiny);
    padding-right: em($global-spacing-unit);
  }


  svg {
    position: absolute;
    right: em($global-spacing-unit-small);
    top: 50%;
    transform: translateY(-50%);
    fill: $color-alpha;

    &.svg-down {
      transform: translateY(-50%) rotate(90deg);
    }
  }

  &.is-open {
    @include focus();
  }
}

.c-filter-checkbox-dropdown {
  margin: 0;
  list-style: none;
  background-color: white;
  position: absolute;
  z-index: 100;
  top: 100%;
  width: 100%;
  min-width: em(265px);
  box-shadow: 0 0 0 3px $color-neutral, 0 0 30px 0 rgba($color-base, .1);
  padding: em($global-spacing-unit-small);
}

.c-filter-checkbox-options {
  max-height: 400px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/form/filters/FilterCheckboxProduct.vue